/**
 * Reset — neues Passwort über Token-Link (?token=…), 1:1 zur Web-App.
 * Gleiche Regeln/Toggles/Match wie Register. Erfolg → Hinweis + zurück zu /login.
 */
import { useState } from "preact/hooks";
import { useLocation } from "preact-iso";
import { endpoints } from "../api/endpoints";
import { ApiError } from "../api/client";
import { BrandHeader } from "../app/BrandHeader";
import { PasswordField } from "../ui/PasswordField";
import { PasswordRules } from "../ui/PasswordRules";
import { passwordValid } from "../ui/password-rules";

function tokenFromUrl(): string {
  try {
    return new URLSearchParams(location.search).get("token") || "";
  } catch {
    return "";
  }
}

export function Reset() {
  const { route } = useLocation();
  const [token] = useState(tokenFromUrl);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState<string | null>(
    tokenFromUrl()
      ? null
      : "Dieser Link ist ungültig. Bitte fordere über die Anmeldeseite einen neuen an.",
  );
  const [busy, setBusy] = useState(false);

  const mismatch = pw2.length > 0 && pw !== pw2;

  async function onSubmit(e: Event) {
    e.preventDefault();
    setError(null);
    if (!token) {
      setError("Dieser Link ist ungültig. Bitte fordere über die Anmeldeseite einen neuen an.");
      return;
    }
    if (!passwordValid(pw)) {
      setError(
        "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens eine Zahl sowie ein Sonderzeichen enthalten.",
      );
      return;
    }
    if (pw !== pw2) {
      setError("Die beiden Passwörter stimmen nicht überein.");
      return;
    }
    setBusy(true);
    try {
      await endpoints.passwordResetConfirm(token, pw);
      sessionStorage.setItem(
        "ki-kurs-login-hinweis",
        "Dein Passwort wurde geändert. Bitte melde dich mit dem neuen Passwort an.",
      );
      route("/login", true);
    } catch (err) {
      setError(
        err instanceof ApiError ? err.detail : "Passwort konnte nicht gesetzt werden.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <main class="auth-screen">
      <div class="auth-stack">
        <div class="glass login-card">
          <BrandHeader />
          <h1>Neues Passwort</h1>
          <p class="sub">Vergib hier ein neues Passwort für deinen Kurszugang.</p>

          <form onSubmit={onSubmit} autocomplete="on">
            <label>
              Neues Passwort
              <PasswordField
                value={pw}
                onInput={setPw}
                placeholder="mindestens 8 Zeichen"
                autocomplete="new-password"
                minLength={8}
                required
              />
            </label>
            <PasswordRules value={pw} />
            <label>
              Passwort wiederholen
              <PasswordField
                value={pw2}
                onInput={setPw2}
                placeholder="Passwort erneut eingeben"
                autocomplete="new-password"
                minLength={8}
                required
                error={mismatch}
              />
            </label>
            {mismatch ? (
              <p class="pw-match" aria-live="polite">
                Die Passwörter stimmen nicht überein.
              </p>
            ) : null}

            <button class="btn" type="submit" disabled={busy}>
              {busy ? "Bitte warten …" : "Passwort speichern"}
            </button>
            {error ? <p class="err">{error}</p> : null}
          </form>

          <p class="hint">
            Doch keinen Wechsel nötig? <a href="/login">Zur Anmeldung</a>.
          </p>
        </div>
      </div>
    </main>
  );
}
